import { ReactNode } from 'react'

export interface CollectionSectionTitleProps {
  title: string
  /** Shown in a muted pill after the title; hidden when null. */
  count?: string | null
  /** Right-aligned actions. */
  trailing?: ReactNode
  /** The row is `{testIdPrefix}-title` (the heading inside it), the pill `{testIdPrefix}-count`. */
  testIdPrefix: string
}

/**
 * A collection page section heading: the display face in bold at 30 px,
 * 36 px on a wide column. It is the page's middle tier: under the banner's
 * collection title and always above every card title in the section (the
 * widest featured card caps at 32 px). Its count sits in a muted pill,
 * actions right. No hairline: the space above carries the break.
 */
export function CollectionSectionTitle(props: CollectionSectionTitleProps) {
  const { title, count = null, trailing, testIdPrefix } = props

  return (
    <div className="flex min-w-0 items-center justify-between gap-3" data-testid={`${testIdPrefix}-title`}>
      <div className="flex min-w-0 items-center gap-3">
        <h2 className="truncate pb-[0.08em] font-display text-[30px] font-bold [:root:not([data-heading-font])_&]:font-normal leading-[1.1] tracking-[-0.015em] text-foreground @[760px]/collection:text-[36px]">
          {title}
        </h2>
        {count ? (
          <span
            className="shrink-0 rounded-full bg-primary/10 px-2.5 py-0.5 text-[13px] font-medium tabular-nums text-foreground/70"
            data-testid={`${testIdPrefix}-count`}
          >
            {count}
          </span>
        ) : null}
      </div>
      {trailing ? <div className="flex shrink-0 items-center gap-2">{trailing}</div> : null}
    </div>
  )
}
